<div class="rename-dataset-modal">
  <div class="dataset-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>Rename Dataset</h1>
    </mode-dialog-header>
  </div>
  <mode-status-banner *ngIf="isDatasetPublished" status="warning" data-test="dataset-published-warning" [showIcon]="true" layout="full-width">
    <span
      >The dataset is published as a table within the data workspace. Renaming the published dataset can disrupt the table and any associated content unless manually corrected through TML</span
    >
  </mode-status-banner>
  <div class="content-container">
    <form [formGroup]="form" (ngSubmit)="handleSubmit()" autocomplete="off">
      <div class="form-field">
        <label class="mode-label" for="datasetName">Name</label>
        <input
          id="datasetName"
          type="text"
          formControlName="datasetName"
          data-test="datasetName"
          class="mode-input"
          capraAutofocus
          [class.mode-input-error]="datasetName?.errors?.invalidName"
          placeholder="Dataset name"
          autocomplete="off"
        />
        <div class="mode-validation-error" *ngIf="datasetName?.invalid && (datasetName?.dirty || datasetName?.touched)">
          <div *ngIf="datasetName?.errors?.required">Name can’t be blank</div>
          <div *ngIf="datasetName?.errors?.invalidName">Name must be 4-64 characters long</div>
          <div *ngIf="datasetName.hasError('invalidNameKey')">This name is already taken in this Report</div>
        </div>
      </div>
      <br />
      <div class="action-buttons">
        <div class="right-actions">
          <capra-button
            type="button"
            data-test="dataset-modal-cancel-button"
            text="Cancel"
            variant="secondary"
            color="neutral"
            (clicked)="close()"
          ></capra-button>
          <capra-button
            type="button"
            data-test="dataset-modal-save-button"
            text="Save"
            color="default"
            [disabled]="!form.valid"
            (clicked)="handleSubmit()"
          ></capra-button>
        </div>
      </div>
    </form>
  </div>
</div>
